import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'

@ngCore.Component({
  imports: [ds.input.datepicker.Component, ds.input.select.singleEc.Component],
  selector: 'atn-scenario-data-tab',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.routeBound.scenarios.Feature} */
  public readonly scenariosFeature = ngCore.inject(
    state.routeBound.scenarios.Feature,
  )

  /** Editing scenario period */
  private readonly _periodSg = ngCore.computed(
    (
      editingScenario = this.scenariosFeature.selectors.editingScenarioDraft.asSignal(),
    ) => editingScenario?.period,
  )

  /** Editing scenario start date */
  public readonly startDateSg = ngCore.computed((period = this._periodSg()) =>
    period?.start !== undefined ? new Date(period.start) : undefined,
  )

  /** Editing scenario end date */
  public readonly endDateSg = ngCore.computed((period = this._periodSg()) =>
    period?.end !== undefined ? new Date(period.end) : undefined,
  )

  /**
   * Method handling start date scenario changes
   */
  public startDateChangeHandler(value: Date | undefined) {
    const period = this._periodSg()

    this.scenariosFeature.actions.editDraft
      .from('ScenarioEditDialog.Tabs.Data.Form.StartDateInput.Changed')
      .dispatch({
        period: {
          end: period?.end,
          includesEnd: period?.includesEnd ?? true,
          includesStart: true,
          start: value?.toISOString(),
        },
      })
  }
  /**
   * Method handling end date scenario changes
   */
  public endDateChangeHandler(value: Date | undefined) {
    const period = this._periodSg()

    this.scenariosFeature.actions.editDraft
      .from('ScenarioEditDialog.Tabs.Data.Form.EndDateInput.Changed')
      .dispatch({
        period: {
          end: value?.toISOString(),
          includesEnd: true,
          includesStart: period?.includesStart ?? true,
          start: period?.start,
        },
      })
  }
}
